/* eslint-disable max-len */
const PAGE = 'halloween';

const idFromData = (dishesData) => Object.values(dishesData)
    .sort((data1, data2) => data1.orderNumber - data2.orderNumber)
    .map((data) => data.id);

export const mainDishesData = {
    4689: {
        id: '4689',
        orderNumber: 1,
        category: 'main',
        description: 'В чёрную-чёрную ночь черникой начиняли галету. Мистически-сочная начинка, как элексир, подарит неземное удовольствие',
        detailContent: {
            content: require('./dishes-data/4689.html'),
            hasCookInfo: false,
            hlwn_howMuch: '900 г на 4-6 человек',
        },
    },

    4688: {
        id: '4688',
        orderNumber: 2,
        category: 'main',
        description: 'Осторожно! Эти глазастые сначала следят, а потом уносят на планету Эндорфинию своим волшебным ароматом какао',
        detailContent: {
            content: require('./dishes-data/4688.html'),
            hasCookInfo: false,
            hlwn_howMuch: '1200 г на 6-8 человек',
        },
    },
    4693: {
        id: '4693',
        orderNumber: 3,
        category: 'main',
        description: 'Эти коварные тыквы не такие, как кажутся. Внутри у них много пикантных секретов, а ещё они таинственно исчезают со стола',
        detailContent: {
            content: require('./dishes-data/4693.html'),
            hasCookInfo: false,
            hlwn_howMuch: '4 шт х по 175 г',
        },
    },
    3828: {
        id: '3828',
        orderNumber: 4,
        category: 'main',
        description: 'Зелье, согревающее своими чарами — облепиха, страсть чили и специй, убаюкивающий мёд и капелька нашего колдовства',
        detailContent: {
            content: require('./dishes-data/3828.html'),
            hasCookInfo: false,
            hlwn_howMuch: '1200 г на 4-6 человек',
        },
    },
};

export const allDishes = idFromData(mainDishesData);

export default {
    pageId: PAGE,
    pathSegment: PAGE,
    pathSegmentEn: PAGE,

    title: 'Хэллоуин | Elementaree',
    description: 'Хэллоуин',
    ogImage: '',
    additionalContent: '',
    onInit: () => { },
    appConfig: {
        v2Layout: true,
        pageId: PAGE,
        city: null,
        period: null,
        firstPeriodStart: '2026-10-26',
        filterByIds: null,
        areAvaliableDishesPersistentForPeriods: true,
        joinDishTitlesinMobile: false,
        dishesData: mainDishesData,
        dishCategories: {
            main: {
                id: 'main',
                title: 'Хэллоуин за 1 час',
                titleEn: '',
                detailsTitle: '',
                description: [],
                enabledDishes: idFromData(mainDishesData),
            },
        },
        canChangePortionsCount: true,
        areDetailsEnabled: true,
        enabledBasketDishIds: [],
        autoFillingBasket: false,
        isCheckoutEnabled: true,
        isLinkToMenuEnabled: true,
        prepareIntervals: null,
        isCheckoutTitleHidden: true,
        ageGate: false,
        openBasketButtonType: 'scrollToCheckout',
        ageGateImage: null,
        payment: 'online',
        availableBasketDishIds: [],
        orderDetailsType: 'trial',
        basketFillingParams: {
            dishes: [
                {
                    dish_id: '4695',
                    portions: 1,
                },
            ],
            saveAddedDishes: true,
        },
    },
};
